// src/config/featureFlags.js
// Build-time feature flags. Set the matching REACT_APP_* variable to the exact
// string 'true' to enable; absent or any other value = disabled. Because these
// are inlined at build time by CRA, flipping one requires a rebuild + redeploy.

// Phase 1 public trial signup — the /t/:code landing page, the /trial form, and
// the /trial-status screen. Kept off until the whole flow is built and reviewed;
// nothing in the app links to these routes regardless.
export const TRIAL_SIGNUP_ENABLED =
  process.env.REACT_APP_TRIAL_SIGNUP_ENABLED === 'true';
